/**
 * POST /v1/user/deactivate — bulk deactivate users in a tenant.
 * Adjust keys if the API contract differs.
 *
 * @param {string} tenantUuid
 * @param {string[]} userUuids
 */
export const buildDeactivateUsersBody = (tenantUuid, userUuids) => ({
  tenant_uuid: tenantUuid,
  user_uuids: userUuids,
});

/** POST /v1/user/activate — same payload shape as deactivate. */
export const buildActivateUsersBody = (tenantUuid, userUuids) => ({
  tenant_uuid: tenantUuid,
  user_uuids: userUuids,
});
